export default __webpack_public_path__ + "static/media/online-payment.64496704.png";